var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loading-screen" }, [
    _c("div", { staticClass: "bg-ring ring-1" }),
    _vm._v(" "),
    _c("div", { staticClass: "bg-ring ring-2" }),
    _vm._v(" "),
    _c("div", { staticClass: "bg-ring ring-3" }),
    _vm._v(" "),
    _c("div", { staticClass: "loading-card" }, [
      _c("img", {
        staticClass: "loading-logo",
        attrs: {
          src: require("../../../assets/dmpLogin.png"),
          alt: "DMP Logo",
        },
      }),
      _vm._v(" "),
      _vm.user && _vm.user.name
        ? _c("div", { staticClass: "welcome-text" }, [
            _vm._v("\n      Welcome, "),
            _c("span", { staticClass: "user-name" }, [
              _vm._v(_vm._s(_vm.user.name)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "loading-label" },
        [
          _c("fa", {
            staticClass: "fa-spin me-2",
            attrs: { icon: ["fas", "spinner"] },
          }),
          _vm._v("\n      Loading Map Management Platform...\n    "),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "progress-track" }, [
      _c("div", { staticClass: "progress-bar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }